import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.new.spacing.xsmall,
  },
  position: {
    minWidth: 17,
    color: theme.new.color.textPrimary,
    textAlign: 'center',
    whiteSpace: 'nowrap',
  },
}));

export default useStyles;
